import Navbar from "../components/Navbar";
import Footer from "../Footer";
import "./PolicyPages.css";

const supportCategories = [
  {
    number: "01",
    title: "Account Support",
    description:
      "Get help with login, OTP verification, Google sign-in, dashboard access, and account-related issues.",
    items: [
      "Login and OTP issues",
      "Google sign-in problems",
      "Dashboard access",
      "Account information requests",
    ],
  },
  {
    number: "02",
    title: "Course Support",
    description:
      "Get assistance with enrollments, course access, batches, learning resources, and program information.",
    items: [
      "Enrollment confirmation",
      "Course and content access",
      "Batch-related questions",
      "Learning program information",
    ],
  },
  {
    number: "03",
    title: "Payment Support",
    description:
      "Get help with payment verification, transaction status, receipts, duplicate payments, and refund requests.",
    items: [
      "Payment verification",
      "Transaction status",
      "Receipt requests",
      "Refund-related questions",
    ],
  },
  {
    number: "04",
    title: "General Support",
    description:
      "Contact our support team for questions about CODEION services, policies, programs, and platform usage.",
    items: [
      "Website assistance",
      "Policy questions",
      "General enquiries",
      "Technical support",
    ],
  },
];

function HelpCenter() {
  return (
    <div className="support-page">
      <Navbar />

      <main className="support-main">
        <div className="support-wrapper">
          <section className="support-hero support-hero-centered">
            <span className="legal-eyebrow">CODEION SUPPORT</span>

            <h1>How can we help you?</h1>

            <p>
              Find the right support for your account, courses, payments,
              enrollment, and use of the CODEION learning platform.
            </p>

            <div className="support-hero-actions">
              <a href="#support-options" className="support-primary-button">
                Explore Support ↓
              </a>

              <a
                href="mailto:support@codeion.in"
                className="support-secondary-button"
              >
                Email Support
              </a>
            </div>
          </section>

          <section id="support-options" className="support-options-section">
            <div className="support-section-heading">
              <span>SUPPORT CATEGORIES</span>

              <h2>Choose how we can help</h2>

              <p>
                Select the support category that best matches your question.
              </p>
            </div>

            <div className="support-card-grid">
              {supportCategories.map((category) => (
                <article className="support-category-card" key={category.title}>
                  <div className="support-category-number">
                    {category.number}
                  </div>

                  <h3>{category.title}</h3>

                  <p>{category.description}</p>

                  <ul>
                    {category.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>

                  <a
                    href={`mailto:support@codeion.in?subject=${encodeURIComponent(
                      `CODEION ${category.title}`
                    )}`}
                  >
                    Get Support →
                  </a>
                </article>
              ))}
            </div>
          </section>

          <section className="support-contact-panel">
            <div>
              <span className="legal-eyebrow">CONTACT INFORMATION</span>

              <h2>CODEION Support Team</h2>

              <p>
                When contacting support, include your registered email address,
                course name, transaction reference when relevant, and a clear
                description of the issue.
              </p>
            </div>

            <div className="support-contact-details">
              <div>
                <span>Email</span>

                <a href="mailto:support@codeion.in">
                  support@codeion.in
                </a>
              </div>

              <div>
                <span>Support Hours</span>
                <strong>Mon–Sat, 10:00 AM–7:00 PM IST</strong>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default HelpCenter;